import 'common/scss/reset.scss'
import '../common/common.scss'
import 'babel-polyfill'
import FastClick from 'fastclick'
import Vue from 'vue'
import Index from './Index.vue'
import Loading from '../common/loading.js'
import Toast from '../common/toast.js'

Vue.config.productionTip = false

Vue.use(Loading)
Vue.use(Toast)
FastClick.attach(document.body)

if (ENV !== 'prod') {
  var VConsole = require('vconsole')
  /* eslint-disable no-unused-vars */
  var vConsole = new VConsole()
}

if (ENV === 'dev') {
  /* eslint-disable no-unused-vars */
  var Mock = require('mockjs')
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(Index)
})



// WEBPACK FOOTER //
// ./src/pages/cs180824/index/index.js